export const eases = {
    linear: (p) => p,
    easeInSine: (p) => -Math.cos(p * (Math.PI / 2)) + 1,
    easeOutSine: (p) => Math.sin(p * (Math.PI / 2)),
    easeInOutSine: (p) => -0.5 * (Math.cos(Math.PI * p) - 1),
    easeInQuad: (p) => p ** 2,
    easeOutQuad: (p) => 1 - (1 - p) ** 2,
    easeInOutQuad: (p) => p < .5 ? (p * 2) ** 2 / 2 : 1 - ((1 - p) * 2) ** 2 / 2,
    easeInCubic: (p) => p ** 3,
    easeOutCubic: (p) => 1 - (1 - p) ** 3,
    easeInOutCubic: (p) => p < .5 ? (p * 2) ** 3 / 2 : 1 - ((1 - p) * 2) ** 3 / 2,
    easeInQuart: (p) => p ** 4,
    easeOutQuart: (p) => 1 - (1 - p) ** 4,
    easeInOutQuart: (p) => p < .5 ? (p * 2) ** 4 / 2 : 1 - ((1 - p) * 2) ** 4 / 2,
    easeInQuint: (p) => p ** 5,
    easeOutQuint: (p) => 1 - (1 - p) ** 5,
    easeInOutQuint: (p) => p < .5 ? (p * 2) ** 5 / 2 : 1 - ((1 - p) * 2) ** 5 / 2,
    easeInExpo: (p) => Math.pow(2, 10 * (p - 1)) - 0.001,
    easeOutExpo: (p) => 1 - Math.pow(2, -10 * p),
    easeInOutExpo: (p) => ((p *= 2) < 1) ? 0.5 * Math.pow(2, 10 * (p - 1)) : 0.5 * (2 - Math.pow(2, -10 * (p - 1))),
    easeInCirc: (p) => 1 - Math.sqrt(1 - Math.pow(p, 2)),
    easeOutCirc: (p) => Math.sqrt(1 - Math.pow(p - 1, 2)),
    easeInOutCirc: (p) => p < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * p, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * p + 2, 2)) + 1) / 2,
    easeInBack: (p) => {
        const c1 = 1.70158;
        const c3 = c1 + 1;
        return c3 * p * p * p - c1 * p * p;
    },
    easeOutBack: (p) => {
        const c1 = 1.70158;
        const c3 = c1 + 1;
        return 1 + c3 * Math.pow(p - 1, 3) + c1 * Math.pow(p - 1, 2);
    },
    easeInOutBack: (p) => {
        const c1 = 1.70158;
        const c2 = c1 * 1.525;
        return p < 0.5
            ? (Math.pow(2 * p, 2) * ((c2 + 1) * 2 * p - c2)) / 2
            : (Math.pow(2 * p - 2, 2) * ((c2 + 1) * (p * 2 - 2) + c2) + 2) / 2;
    },
    easeInElastic: (p) => {
        const c4 = (2 * Math.PI) / 3;
        return p === 0
            ? 0
            : p === 1
                ? 1
                : -Math.pow(2, 10 * p - 10) * Math.sin((p * 10 - 10.75) * c4);
    },
    easeOutElastic: (p) => {
        const c4 = (2 * Math.PI) / 3;
        return p === 0
            ? 0
            : p === 1
                ? 1
                : Math.pow(2, -10 * p) * Math.sin((p * 10 - 0.75) * c4) + 1;
    },
    easeInOutElastic: (p) => {
        const c5 = (2 * Math.PI) / 4.5;
        return p === 0
            ? 0
            : p === 1
                ? 1
                : p < 0.5
                    ? -(Math.pow(2, 20 * p - 10) * Math.sin((20 * p - 11.125) * c5)) / 2
                    : (Math.pow(2, -20 * p + 10) * Math.sin((20 * p - 11.125) * c5)) / 2 + 1;
    },
    easeInBounce: (p) => 1 - eases.easeOutBounce(1 - p),
    easeOutBounce: (p) => {
        const n1 = 7.5625;
        const d1 = 2.75;
        if (p < 1 / d1)
            return n1 * p * p;
        if (p < 2 / d1)
            return n1 * (p -= 1.5 / d1) * p + 0.75;
        if (p < 2.5 / d1)
            return n1 * (p -= 2.25 / d1) * p + 0.9375;
        return n1 * (p -= 2.625 / d1) * p + 0.984375;
    },
    easeInOutBounce: (p) => p < 0.5 ? (1 - eases.easeOutBounce(1 - 2 * p)) / 2 : (1 + eases.easeOutBounce(2 * p - 1)) / 2
};
export const easesArray = [
    "linear",
    "easeInSine",
    "easeOutSine",
    "easeInOutSine",
    "easeInQuad",
    "easeOutQuad",
    "easeInOutQuad",
    "easeInCubic",
    "easeOutCubic",
    "easeInOutCubic",
    "easeInQuart",
    "easeOutQuart",
    "easeInOutQuart",
    "easeInQuint",
    "easeOutQuint",
    "easeInOutQuint",
    "easeInExpo",
    "easeOutExpo",
    "easeInOutExpo",
    "easeInCirc",
    "easeOutCirc",
    "easeInOutCirc",
    "easeInBack",
    "easeOutBack",
    "easeInOutBack",
    "easeInElastic",
    "easeOutElastic",
    "easeInOutElastic",
    "easeInBounce",
    "easeOutBounce",
    "easeInOutBounce",
];
